module.exports = __webpack_public_path__ + "img/logo-primary.7267a754.png";